import { useContext, useState } from 'react'
import { OtherContext } from '../../context api/Others/OtherContext'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { API_URL } from '../../shared/actions'

export const useUploadDataStatus = () => {
  const [uploadDataStatus, setUploadDataStatus] = useState(false)
  const { getNewUploadedData } = useContext(OtherContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE, DELETE } = useRestApi(setLoading, 'UploadDataStatus', 'UPLOAD_DATA', 'GET_ALL_UPLOAD_DATA')
  const {
    REGION: { GET_ALL_REGION_BY_COMPANY, ADD_REGION, EDIT_REGION, GET_REGION, DELETE_MANY_REGION },
  } = API_URL

  const getAllUploadDataStatus = async (dto = {}) => {
    GET_ALL('GET_ALL_UPLOAD_DATA', setPaginate, getNewUploadedData, dto)
  }

  // const addUploadDataStatus = (dto) => {
  //   ADD(ADD_REGION, dto)
  // }

  // const updateUploadDataStatus = (dto) => {
  //   UPDATE(EDIT_REGION, dto)
  // }

  // const getUploadDataStatus = (dto) => {
  //   GET_SINGLE_DATA(GET_REGION, setUploadDataStatus, dto.uploadDataStatusId)
  // }

  // const deleteManyUploadDataStatus = (dto, setSelected = () => {}) => {
  //   DELETE(DELETE_MANY_REGION, dto, 'uploadDataStatusId', setSelected, deleteNewUploadDataStatus, 'GET_ALL_REGION_BY_COMPANY')
  // }

  return {
    // addUploadDataStatus,
    getAllUploadDataStatus,
    // getUploadDataStatus,
    uploadDataStatus,
    // updateUploadDataStatus,
    // deleteManyUploadDataStatus,
    loading,
    paginate,
  }
}
